import { zodResolver } from "@hookform/resolvers/zod";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useIssuanceLetterApplicationMutation } from "api/applications/applications.mutation";
import DatePickerField from "components/DatePickerField";
import { Modal } from "components/Modal";
import SelectField from "components/Select";
import TextField from "components/TextField";
import { YEAR_SEASON_OPTIONS } from "constants/options";
import { handleError } from "functions/apiHandleError";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/applicationDetail/issuanceModal";

const YearOptions = () => {
  let now_year = new Date().getFullYear() - 3;
  const list_years = [];
  Array.from(Array(7).keys()).map(() => {
    list_years.push({ value: `${now_year}-${now_year + 1}`, label: `${now_year}-${now_year + 1}` });
    now_year += 1;
  });
  return list_years;
};

const IssuanceModal = ({ open, onClose, selectedApplication }) => {
  const { control, handleSubmit, setError, reset } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    defaultValues: {
      count_semesters: "",
      fee: "",
      semesters_year: "",
      semesters_season: "",
      register_start_date: "",
      register_end_date: "",
      start_program_date: "",
    },
  });

  const issuanceLetterApplicationMutation = useIssuanceLetterApplicationMutation();

  const handleCloseModal = () => {
    reset();
    onClose();
  };

  const onSubmit = async (data) => {
    try {
      await issuanceLetterApplicationMutation.mutateAsync({
        application: selectedApplication.id,
        count_semesters: data?.count_semesters,
        fee: data?.fee,
        semesters_year: data?.semesters_year,
        semesters_season: data?.semesters_season,
        register_start_date: data?.register_start_date,
        register_end_date: data?.register_end_date,
        start_program_date: data?.start_program_date,
      });
      handleCloseModal();
      toast.success("با موفقیت ثبت شد");
    } catch (err) {
      handleError({ err, setError });
    }
  };

  useEffect(() => {
    let now_year = new Date().getFullYear();
    let now_month = new Date().getMonth() + 1;
    reset({
      count_semesters:
        selectedApplication?.degree === "Bachelor"
          ? "8"
          : selectedApplication?.degree === "Master"
          ? "4"
          : "6",
      fee:
        selectedApplication?.degree === "Bachelor"
          ? "800"
          : selectedApplication?.degree === "Master"
          ? "900"
          : "1100",
      semesters_year: `${now_year}-${now_year + 1}`,
      semesters_season: [10, 11, 12, 1].includes(now_month) ? "Winter" : "Fall",
      register_start_date: "2025-09-14",
      register_end_date: "2025-09-18",
      start_program_date: "2025-09-22",
    });
  }, [selectedApplication]);

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      title="لطفا اطلاعات زیر را پر کنید"
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={issuanceLetterApplicationMutation.isPending}
            color="success"
            onClick={handleSubmit(onSubmit)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid container direction="row-reverse" spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="تعداد ترم مورد نیاز برای گذراندن"
            name="count_semesters"
            control={control}
            number
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="شهریه ترمی دانشگاه  (یورو)"
            name="fee"
            control={control}
            number
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            label="سال تحصیلی"
            control={control}
            name="semesters_year"
            options={YearOptions()}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            label="فصل تحصیلی"
            control={control}
            name="semesters_season"
            options={YEAR_SEASON_OPTIONS}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField name="register_start_date" control={control} required />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField name="register_end_date" control={control} required />
        </Grid>
        <Grid item xs={12}>
          <DatePickerField name="start_program_date" control={control} required />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default IssuanceModal;
